<div class="layout-buttons-container">
	<!-- 1x1 Single -->
	<button
		class="layout-btn"
		[class.active]="layoutService.isLayout(VideoLayout.SINGLE)"
		title="Single View"
		(click)="layoutService.setLayout(VideoLayout.SINGLE)"
	>
		<svg viewBox="0 0 24 18" fill="none">
			<rect x="2" y="2" width="20" height="14" rx="2" fill="currentColor" />
		</svg>
	</button>
	<!-- 1x2 Side by Side -->
	<button
		class="layout-btn"
		[class.active]="layoutService.isLayout(VideoLayout.SIDE_BY_SIDE)"
		title="Side by Side"
		(click)="layoutService.setLayout(VideoLayout.SIDE_BY_SIDE)"
	>
		<svg viewBox="0 0 24 18" fill="none">
			<rect x="2" y="2" width="9.5" height="14" rx="1.5" fill="currentColor" />
			<rect x="12.5" y="2" width="9.5" height="14" rx="1.5" fill="currentColor" />
		</svg>
	</button>

	<button
		class="layout-btn"
		[class.active]="layoutService.isLayout(VideoLayout.STACKED)"
		title="Stacked"
		(click)="layoutService.setLayout(VideoLayout.STACKED)"
	>
		<svg viewBox="0 0 18 24" fill="none">
			<rect x="2" y="2" width="14" height="9.5" rx="1.5" fill="currentColor" />
			<rect x="2" y="12.5" width="14" height="9.5" rx="1.5" fill="currentColor" />
		</svg>
	</button>

	<!-- Large Left -->
	<button
		class="layout-btn"
		[class.active]="layoutService.isLayout(VideoLayout.LARGE_LEFT)"
		title="Large Left"
		(click)="layoutService.setLayout(VideoLayout.LARGE_LEFT)"
	>
		<svg viewBox="0 0 24 18" fill="none">
			<rect x="2" y="2" width="14" height="14" rx="1.5" fill="currentColor" />
			<rect x="17" y="2" width="5" height="6.5" rx="1" fill="currentColor" />
			<rect x="17" y="9.5" width="5" height="6.5" rx="1" fill="currentColor" />
		</svg>
	</button>
	<!-- Large Right -->
	<button
		class="layout-btn"
		[class.active]="layoutService.isLayout(VideoLayout.LARGE_RIGHT)"
		title="Large Right"
		(click)="layoutService.setLayout(VideoLayout.LARGE_RIGHT)"
	>
		<svg viewBox="0 0 24 18" fill="none">
			<rect x="2" y="2" width="5" height="6.5" rx="1" fill="currentColor" />
			<rect x="2" y="9.5" width="5" height="6.5" rx="1" fill="currentColor" />
			<rect x="8" y="2" width="14" height="14" rx="1.5" fill="currentColor" />
		</svg>
	</button>
	<!-- 2x2 Grid -->
	<button
		class="layout-btn"
		[class.active]="layoutService.isLayout(VideoLayout.GRID_2X2)"
		title="2×2 Grid"
		(click)="layoutService.setLayout(VideoLayout.GRID_2X2)"
	>
		<svg viewBox="0 0 24 18" fill="none">
			<rect x="2" y="2" width="9.5" height="6.5" rx="1" fill="currentColor" />
			<rect x="12.5" y="2" width="9.5" height="6.5" rx="1" fill="currentColor" />
			<rect x="2" y="9.5" width="9.5" height="6.5" rx="1" fill="currentColor" />
			<rect x="12.5" y="9.5" width="9.5" height="6.5" rx="1" fill="currentColor" />
		</svg>
	</button>
</div>
